import { Col, Row } from 'antd';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../utilz/i18n';
import Button from '../../../components/Buttons/Button';
import FormLabel from '../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import Paper from '../../../components/Paper/Paper';
import type { PostalInfo } from '../types';

interface PostalSearchCardProps {
  data: PostalInfo;
  handleSelect: (data: PostalInfo) => void;
}

const PostalSearchCard: FC<PostalSearchCardProps> = ({ data, handleSelect }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Paper className="mb-15 py-10 px-15" border>
      <Row gutter={15} align="middle">
        <Col flex={1}>
          <Row gutter={15} align="middle">
            <Col sm={6}>
              <FormLabel>{t('translation:default.fields.city.label')}</FormLabel>
              <br />
              <SecondaryLabel className="f-14 fw-600">{data?.city}</SecondaryLabel>
            </Col>
            <Col sm={6}>
              <FormLabel>{t('translation:default.fields.stateProvince.label')}</FormLabel>
              <br />
              <SecondaryLabel className="f-14 fw-600">{data?.stateDesc}</SecondaryLabel>
            </Col>
            <Col sm={6}>
              <FormLabel>{t('translation:default.fields.postalCode.label')}</FormLabel>
              <br />
              <SecondaryLabel className="f-14 fw-600">{data?.zip}</SecondaryLabel>
            </Col>
            <Col sm={6}>
              <FormLabel>{t('translation:default.fields.country.label')}</FormLabel>
              <br />
              <SecondaryLabel className="f-14 fw-600">{data?.countryName}</SecondaryLabel>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button onClick={() => handleSelect(data)}>{t('translation:default.buttons.select')}</Button>
        </Col>
      </Row>
    </Paper>
  );
};

export default PostalSearchCard;
